export default __webpack_public_path__ + "static/media/map_pin.152d6f9f.svg";